//import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect,
	MultiSelect
} from 'vue-search-select'
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
import Loader from '../../../../shared/components/loader'
import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import CONSTANT from './../../../../shared/constants/constant'
import Multiselect from 'vue-multiselect'
import {
	Validator
} from 'vee-validate';
import CryptoJS from 'crypto-js';
import {
	isReactive
} from 'vue';

export default {
	name: 'MarketVehicleApprovalFlow',
	components: {
		//VueElementLoading,
		Pagination,
		BasicSelect,
		Loader,
		CustomExpandableTable,
		Multiselect,
		Validator

	},
	data: function () {
		return {
			approvalObject: "client",
			data: [{

			}],
			selectedRoles: {
				text: '',
				value: ''
			},
			roleList: [],
			userList: [],
			userId: [],
			role: "",
			isLoading: false,
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			pageLimit: CONSTANT.PER_PAGE_DATA,
			form: {
				role: [],
				user: [],
			},
			approvelData: [{
				maxcostlimit: '',
				mincostlimit: '',
				maxcostlimitError: '',
				mincostlimitError: '',
				userId: [],
				userError: ''
			}],
			rolesList: [],
			createdby: '',
			buttonText: 'Save',
			intialapprovalData: [],
			branchName: null,
			branchNameList: [],
			mincostlimit: [],
			maxcostlimit: [],
			minlimit: 0,
			maxlimit: '',
			userdata: '',
			userdatalist: '',
			selectedUsers: [],
			selectedUsersData:[]

		}
	},
	computed: {

	},
	async mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.localuserid = userdetail.userid;
		this.defaultHubID = userdetail.hubID[0];
		this.createdby = userdetail.email;
		await Promise.all([this.getHubAccessList()])
		await this.getApprovalHierarchyUser();
	},
	methods: {
		isNumber: function (evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (
				charCode > 31 &&
				(charCode < 48 || charCode > 57) &&
				charCode !== 46
			) {
				evt.preventDefault();
			} else {
				return true;
			}
		},

		async getHubAccessList() {
			try {
				let InputPayload = {
					userid: this.localuserid
				}
				this.isLoading = true;
				let response = await TripServices.getHubAccessList(InputPayload)
				this.isLoading = false;
				let list = response.data.data.hubaccess
				list.forEach(el => {
					this.branchNameList.push({
						'id': el.HubID,
						'label': el.HubName
					})
					if (el.HubID == this.defaultHubID) {
						this.branchName = {
							'id': el.HubID,
							'label': el.HubName
						}
						this.userListAgainstRoles(this.branchName)
					}
				})
			} catch (err) {
				this.isLoading = false;
			}
		},
		async userListAgainstRoles(branchName) {
			this.userList =[]
			this.selectedUsers = []
			this.isLoading = true;
			let InputPayload = {
				hubid:branchName.id
			}
			let result = await TripServices.getAllRolesUsers(InputPayload);
			this.isLoading = false;
			if (result.data.code == 200) {
				let temp = result.data.data
				temp.forEach((item) => {
					let tmp = {
						'id': item.userid,
						'label': item.username,
						'text': item.email,
						'$isDisabled':item.disable
					}
					if(item.disable){
						this.selectedUsers.push(item.userid);
					}
					this.userList.push(tmp)
				})
			} else {
				this.userList = [];
				this.$alert("Internal Server Error", 'Approval Hierarchy', "error");
			}
		},
		selectBranchName(branchname) {
			this.branchName = branchname
			if (branchname) {
				this.userListAgainstRoles(branchname)
				this.getApprovalHierarchyUser();
			}
		},
		addNewRow(index) {
			let isError = 0;

			if (this.approvelData[index].mincostlimit == '' || this.approvelData[index].mincostlimit == null) {
				this.approvelData[index].mincostlimitError = "Please Enter Minimum Cost Limit.";
				isError = 1;
			} else {
				if (this.approvelData[index].maxcostlimit != '' && index > 0) {
					if (parseInt(this.approvelData[index].mincostlimit) <= parseInt(this.approvelData[index - 1].maxcostlimit)) {
						this.approvelData[index].mincostlimitError = `Minimum cost limit should be greater than ${this.approvelData[index - 1].maxcostlimit}`;
						isError = 1;
					} else {
						this.approvelData[index].mincostlimitError = '';
					}
				} else {
					this.approvelData[index].mincostlimitError = '';
				}
			}

			if (this.approvelData[index].maxcostlimit == '' || this.approvelData[index].maxcostlimit == undefined) {
				this.approvelData[index].maxcostlimitError = "Please Enter Maximum Cost Limit.";
				isError = 1;
			} else {
				if (parseInt(this.approvelData[index].maxcostlimit) <= parseInt(this.approvelData[index].mincostlimit)) {
					this.approvelData[index].maxcostlimitError = `Maximum cost limit should be greater than ${this.approvelData[index].mincostlimit}`;
					isError = 1;
				} else {
					this.approvelData[index].maxcostlimitError = '';
				}
			}

			if (this.approvelData[index].userId.length == 0) {
				this.approvelData[index].userError = "Please select User.";
				isError = 1;
			} else if(this.approvelData[index].userId.length < 2){
				this.approvelData[index].userError = "Each Level of approver should have atleast 2 Approvers.";
				isError = 1;
			}else{
				this.approvelData[index].userError = '';
			}
			if (isError == 1) {
				return true;
			} else {
				this.maxlimit = this.approvelData[index].maxcostlimit
			}
			this.approvelData.push({
				maxcostlimit: '',
				mincostlimit: '',
				maxcostlimitError: '',
				mincostlimitError: '',
				userId: [],
				userError: ''
			});
		},
		deleteRow(data,index) {
			this.$confirm(`You are going to delete Approval Levels ${index}. Please confirm.`, '', 'question').then(() => {
				data.userId.map(item=>{
					let userid = item.id.toString();
					const index = this.userList.findIndex(opt=>opt.id === userid)
					if(index !==-1){
						this.$set(this.userList[index],'$isDisabled',false);
					}
				})
				this.approvelData.splice(index, 1);
			}).catch((err)=>{
				console.log(err)
			});
		},
		clearForm() {
			this.currentPage = 1,
				this.totalPage = 0,
				this.totalCount = 0,
				this.pageLimit = 10,
				this.$validator.reset();
		},
		onPageChange(page) {
			this.currentPage = page;
		},
		ShowApprovalObjectInput() {},

		removeUserError(data, index) {
			if (data.length == 0) {
				this.approvelData[index].userError = 'Please select User.';
			} else {
				this.approvelData[index].userError = '';
			}
		},
		onUserSelect(data){
			let userid = data.id;
			if(this.selectedUsers.includes(userid)){
				this.$alertify.error("User already selected in the Approver List");
			}
		},
		onUserRemove(data){
			let userid = data.id.toString()
			let itemIndex = this.selectedUsers.indexOf(userid);
			if(itemIndex!==-1){
				this.selectedUsers.splice(itemIndex,1);
			}
			const index = this.userList.findIndex(opt=>opt.id === userid)
			if(index !==-1){
				this.$set(this.userList[index],'$isDisabled',false);
			}
		},
	  
		async getApprovalHierarchyUser() {
			try {
				let payload = {}
				if (this.branchName) {
					payload.hubid = this.branchName.id
				} else {
					payload.hubid = this.defaultHubID
				}
				this.isLoading = true;
				var getUserList = [];
				await TripServices.getApprovalHierarchyUsers(payload).then(async result => {
					getUserList = await result.data.data;
					if (getUserList.length == 0) {
						this.buttonText = 'Save';
						this.approvelData = [{
							mincostlimit: '',
							maxcostlimit: '',
							userId: [],
							userError: ''
						}];
						this.intialapprovalData = [];
						this.isLoading = false;
						return true;
					} else {
						this.approvelData = [];
						this.intialapprovalData = getUserList;
						this.buttonText = 'Update';
						for (var i = 0; i < getUserList.length; i++) {
							let getUsers = {};
							getUsers.mincostlimit = getUserList[i].lowerlimit
							getUsers.mincostlimitError = ''
							getUsers.maxcostlimit = getUserList[i].higherlimit
							getUsers.maxcostlimitError = ''
							getUsers.userId = getUserList[i].userdetails
							getUsers.id = getUserList[i].id
							getUsers.userError = '';
							this.minlimit = getUserList[i].lowerlimit
							this.maxlimit = getUserList[i].higherlimit
							this.approvelData.push(getUsers);
						}
						this.isLoading = false;
					}
				});
			} catch (err) {
				this.isLoading = false;
				this.$alert('Resource Request Timed Out', 'Approval Hierarchy', 'error')
			}
		},
		async saveApprovalHierarchy() {
			try {
				this.isLoading = true;
				let payload = {};
				payload.userHierarchyData = [];
				for (var i = 0; i < this.approvelData.length; i++) {
					let levelObj = {};
					levelObj.levelNumber = i + 1;
					levelObj.mincostlimit = parseInt(this.approvelData[i].mincostlimit);
					levelObj.maxcostlimit = this.approvelData[i].maxcostlimit != "" ? parseInt(this.approvelData[i].maxcostlimit) : null;
					let userInfo = [];
					for (var z = 0; z < this.approvelData[i].userId.length; z++) {
						let userInfoObj = {};
						userInfoObj.userID = parseInt(this.approvelData[i].userId[z].id);
						userInfoObj.userName = this.approvelData[i].userId[z].label;
						userInfoObj.userEmail = this.approvelData[i].userId[z].text;
						userInfo.push(userInfoObj);
					}
					levelObj.userInfo = userInfo;
					levelObj.status = 1;
					levelObj.hubID = this.branchName.id
					levelObj.hubName = this.branchName.label

					payload.userHierarchyData.push(levelObj)
					payload.createdby = this.createdby
				}
				let result = await TripServices.createHerarchyUser(payload);
				this.isLoading = false;
				if (result.data.code == 200) {
					this.$alert("Approval Flow Configuration created successfully", 'Approval Hierarchy', "success");
					this.buttonText = 'Save';
					this.approvelData = [{
						maxcostlimit: '',
						mincostlimit: '',
						maxcostlimitError: '',
						mincostlimitError: '',
						userId: [],
						userError: ''
					}];
					this.getApprovalHierarchyUser();
				}
			} catch (error) {
				this.isLoading = false;
			}

		},
		async updateApprovalHierarchy() {
			try {
				this.isLoading = true;
				let isError = 0;
				let objApprovalData = {};
				objApprovalData.hubid = this.branchName.id;
				objApprovalData.hubname = this.branchName.label
				objApprovalData.createdby = this.createdby;
				objApprovalData.userHierarchyData = [];
				let approvelDatalength = this.approvelData.length
				for (var i = 0; i < approvelDatalength; i++) {
					let userData = [];
					let temp = {
						maxcostlimit: null,
						mincostlimit: null
					}

					if (this.approvelData[i].id) {
						temp.id = this.approvelData[i].id;
					}
					for (var j = 0; j < this.approvelData[i].userId.length; j++) {
						let userObjTemp = {};
						userObjTemp.userID = parseInt(this.approvelData[i].userId[j].id);
						userObjTemp.userName = this.approvelData[i].userId[j].label;
						if (this.approvelData[i].userId[j].text) {
							userObjTemp.userEmail = this.approvelData[i].userId[j].text;
						} else {
							userObjTemp.userEmail = this.approvelData[i].userId[j].email;
						}
						userData.push(userObjTemp);
					}
					temp.mincostlimit = parseInt(this.approvelData[i].mincostlimit);
					temp.maxcostlimit = parseInt(this.approvelData[i].maxcostlimit);
					temp.status = 1;
					temp.levelNumber = i + 1;
					temp.userData = userData;
					objApprovalData.userHierarchyData.push(temp);
				}
				let result = await TripServices.updateApprovalUsers(objApprovalData);
				this.isLoading = false;
				if (result.data.code == 200) {
					this.$alert("Record saved successfully.", 'Approval Hierarchy', 'success');
					this.buttonText = 'Save';
					this.approvelData = [{
						mincostlimit: '',
						mincostlimitError: '',
						maxcostlimit: '',
						maxcostlimitError: '',
						userId: [],
						userError: '',
					}];
					this.getApprovalHierarchyUser();
				} else {
					this.$alert('Resource Request Timed Out', 'Approval Hierarchy', 'error')
				}
			} catch (err) {
				this.isLoading = false;
				this.$alert('Resource Request Timed Out', 'Approval Hierarchy', 'error')
			}
		},
		async onSubmit() {
			if (this.approvelData.length > 0) {
				this.selectedUsersData=[]
				let isError = 0;
				let approvelDatalength = this.approvelData.length;
				for (var i = 0; i < this.approvelData.length; i++) {
					if (this.approvelData[i].mincostlimit == '' || this.approvelData[i].mincostlimit == undefined) {
						this.approvelData[i].mincostlimitError = "Please Enter Minimum Cost Limit.";
						isError = 1;
					} else {
						if (i) {
							if (parseInt(this.approvelData[i].mincostlimit) <= parseInt(this.approvelData[i - 1].maxcostlimit)) {
								this.approvelData[i].mincostlimitError = `Minimum cost limit should be greater than ${this.approvelData[i - 1].maxcostlimit}`;
								isError = 1;
							} else {
								this.approvelData[i].mincostlimitError = '';
							}
						} else {
							this.approvelData[i].mincostlimitError = '';
						}
					}

					if ((this.approvelData[i].maxcostlimit == '' || this.approvelData[i].maxcostlimit == undefined) && (approvelDatalength - i) > 1) {
						this.approvelData[i].maxcostlimitError = "Please Enter Maximum Cost Limit.";
						isError = 1;
					} else {
						if (parseInt(this.approvelData[i].maxcostlimit) <= parseInt(this.approvelData[i].mincostlimit)) {
							this.approvelData[i].maxcostlimitError = `Maximum cost limit should be greater than ${this.approvelData[i].mincostlimit}`;
							isError = 1;
						} else {
							this.approvelData[i].maxcostlimitError = '';
						}
					}
					if (this.approvelData[i].userId.length == 0) {
						this.approvelData[i].userError = "Please select User.";
						isError = 1;
					} else if(this.approvelData[i].userId.length < 2){
						this.approvelData[i].userError = "Each Level of approver should have atleast 2 Approvers.";
						isError = 1;
					}else{
						this.approvelData[i].userId.map(item=>{
							let userid = parseInt(item.id);
							if(this.selectedUsersData.includes(userid)){
								this.approvelData[i].userError = `${item.label} user already added in Approver list.`;
								isError = 1;
								return true;
							}else{
								this.selectedUsersData.push(userid)
							}
						})
						if(!isError){
							this.approvelData[i].userError = '';
						}
					}
				}
				if (isError == 1) {
					return true;
				} else {
					if (this.buttonText == 'Save') {
						this.saveApprovalHierarchy();
					} else {
						this.updateApprovalHierarchy();
					}
				}

			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/marketvehicleflm/vehiclerequestapprovalflow/vehiclerequestapprovalflow.component.js